import { z } from 'zod';
import { isoDateTime } from './common.js';
import { userChannelSchema } from './users.js';
export const activityTypeSchema = z.enum(['reply', 'retrieve', 'blocked', 'error']);
/** Provider and user text inside `text` is untrusted: the panel escapes it. */
export const activityItemSchema = z.object({
    id: z.string(),
    at: isoDateTime,
    type: activityTypeSchema,
    sourceKind: z.string().optional(),
    sourceId: z.string().optional(),
    channel: userChannelSchema.optional(),
    text: z.string(),
    actor: z.object({ id: z.string(), name: z.string() }).optional(),
});
/**
 * Where the next page starts: `<ISO time>_<id>` of the last row shown. Opaque
 * to the panel, which only hands it back.
 */
export const activityCursorSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}T[\d:.]+Z_[0-9A-Za-z-]+$/, 'not a cursor this API issued');
//# sourceMappingURL=activity.js.map